export const PHONE_NUMBER_REGEX = /^01([0|1|6|7|8|9])-?([0-9]{4})-?([0-9]{4})$/;
export const NUMBER_ONLY_REGEX = /[^0-9]/g;

export const getTextMessageLength = (str: string) => {
  let len = 0;
  // charCodeAt(0) >= 128 means it is a non-ASCII character
  for (const char of str) len += char.charCodeAt(0) > 127 ? 2 : 1;
  return len;
};

export const getDeviceLocationText = (location: DeviceLocation): string => {
  switch (location) {
    case 'app':
      return '앱 키오스크';
    case 'outer':
      return 'Windows 키오스크 (외부)';
    case 'inner':
      return 'Windows 키오스크 (내부)';
    default:
      return '-';
  }
};

/**
 * 한글 종성 판정
 * @param text 대상 문자열
 * @param particleToUse 사용하고자 하는 조사
 * @returns 문자열에 맞는 조사
 */
export const getParticleFromText = (
  text: string,
  particleToUse: '은' | '는' | '이' | '가' | '을' | '를' | '으로' | '로',
) => {
  const currentCharCode = text.charCodeAt(text.length - 1);
  if (currentCharCode < 0xac00 || currentCharCode > 0xd7a3) return '';
  const jongseongUsed = (currentCharCode - 0xac00) % 28 > 0;
  if (jongseongUsed) {
    if (particleToUse === '은' || particleToUse === '는') return '은';
    if (particleToUse === '이' || particleToUse === '가') return '이';
    if (particleToUse === '으로' || particleToUse === '로') return '으로';
    return '을';
  } else {
    if (particleToUse === '은' || particleToUse === '는') return '는';
    if (particleToUse === '이' || particleToUse === '가') return '가';
    if (particleToUse === '으로' || particleToUse === '로') return '로';
    return '를';
  }
};
